import React from 'react';
import { View } from 'react-native';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { shimmerPlaceholderConfig } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import {
  headerLoadingConfig,
  firstCardLoadingConfig,
  secondCardLoadingConfig,
  lastLineLoadingConfig,
} from './BudgetLoading.Config';
import styles from './BudgetLoading.Styles';

function BudgetLoading() {
  const theme = useTheme();
  const renderFirstCard = () => {
    return (
      <View style={styles.marginBottom(28)}>
        {[0, 1].map(key => (
          <View style={styles.cardContainerStyle(theme)} key={key}>
            <Shimmer
              config={firstCardLoadingConfig}
              shimmerPlaceholderConfig={shimmerPlaceholderConfig}
            />
          </View>
        ))}
      </View>
    );
  };
  const renderSecondCard = () => {
    return (
      <View style={styles.marginBottom(35)}>
        {[2, 3].map(key => (
          <View style={styles.cardContainerStyle(theme)} key={key}>
            <Shimmer
              config={secondCardLoadingConfig(theme)}
              shimmerPlaceholderConfig={shimmerPlaceholderConfig}
            />
          </View>
        ))}
      </View>
    );
  };
  const renderHeader = () => (
    <View style={styles.headerContainer}>
      <Shimmer config={headerLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
    </View>
  );
  const renderLastLine = () => {
    return (
      <Shimmer config={lastLineLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
    );
  };
  return (
    <View style={styles.containerStyle}>
      {renderHeader()}
      {renderFirstCard()}
      {renderHeader()}
      {renderSecondCard()}
      {renderLastLine()}
    </View>
  );
}

export default BudgetLoading;
